/* eslint-disable vue/no-unused-vars */
<template>
  <div>
    <a-card :loading="loading" style="margin-bottom:1rem">
      <div slot="title">
        <a-row>
          <a-col :xs="3" :md="2" :lg="1">
            <a-button
              type="primary"
              size="small"
              icon="left"
              shape="circle"
              class="back-button"
              style="margin-right:1rem;"
              @click="backButton"
            />
          </a-col>
          <a-col :xs="21" :md="22" :lg="23">
            <a-skeleton
              v-if="loading"
              :paragraph="false"
              :avatar="false"
              :title="{ width: '90%' }"
              active
            />
            <span v-else>
              <h3 class="main-card-title">
                <a-icon type="user"></a-icon> {{ customer.firstName }}
                {{ customer.lastName }}
              </h3>
            </span>
          </a-col>
        </a-row>

        <!--<a-icon @click="backButton()" type="arrow-left">Volver </a-icon>-->
      </div>
      <!--
      <a-switch
        slot="extra"
        style="margin-left:1em"
        checkedChildren="Activo"
        unCheckedChildren="Inactivo"
        @change="handleStatusSwitch"
        :checked="subscriberActive"
        :disabled="switchDisabled"
        :loading="switchLoader"
      />
      -->
      <h3 v-if="customer.phone1">
        <strong>Teléfono:</strong>&nbsp;
        <a :href="'https://wa.me/' + customer.phone1" target="_blank"
          ><i class="icmn-whatsapp" />&nbsp;{{ customer.phone1 }}</a
        >
      </h3>
      <h3>
        <strong>Email:</strong>
        <a :href="'mailto:' + customer.email">
          {{ customer.email }}
        </a>
      </h3>
      <h3>
        <strong>Fecha de Alta:</strong>
        {{ customer.createdAt | moment("DD/MM/YYYY") }}
      </h3>
      <!--
      <div style="margin-bottom:1.5rem">
        <h3><strong>Tarjetas:</strong></h3>
        <ul>
          <li v-for="card in customer.paymentCards" :key="card.id">
            {{ card.ownerName }}
            <span style="text-transform:uppercase">{{
              card.paymentCourier.name
            }}</span>
            xxxx xxxx xxxx {{ card.lastFourDigits }} exp:
            {{ $moment(card.expirationDate).format("MM/YY") }}
          </li>
        </ul>
      </div>
			-->
      <div>
        <a-divider orientation="left">Suscripciones</a-divider>
        <a-list :dataSource="customer.subscriptions" size="small">
          <a-list-item slot="renderItem" slot-scope="item" key="item.id">
            <a-list-item-meta>
              <div
                v-if="
                  (item.subscriptionsCustomers.status == '1' ||
                    item.subscriptionsCustomers.status == '5') &&
                    item.subscriptionsCustomers.lastFailedDebitAttempt
                "
                slot="avatar"
                :class="$style.avatarDiv"
              >
                <div :class="$style.avatarWithId">
                  <a-avatar :class="$style.orange" icon="tag" />
                </div>
              </div>

              <div
                v-else-if="item.subscriptionsCustomers.status == '1'"
                slot="avatar"
                :class="$style.avatarDiv"
              >
                <div :class="$style.avatarWithId">
                  <a-avatar :class="$style.green" icon="tag" />
                </div>
              </div>

              <div
                v-else-if="item.subscriptionsCustomers.status == '5'"
                slot="avatar"
                :class="$style.avatarDiv"
              >
                <div :class="$style.avatarWithId">
                  <a-avatar :class="$style.blue" icon="tag" />
                </div>
              </div>

              <div v-else slot="avatar" :class="$style.avatarDiv">
                <div :class="$style.avatarWithId">
                  <a-avatar :class="$style.pink" icon="tag" />
                </div>
              </div>

              <h4 class="transaction" slot="title">
                <router-link :key="'view'" :to="`/subscriptions/${item.id}`">
                  {{ item.name }}

                  <span class="transaction-gray-text">
                    #{{ item.id }}</span
                  > </router-link
                >&nbsp;
                <span id="status">
                  <span
                    v-if="
                      (item.subscriptionsCustomers.status == '1' ||
                        item.subscriptionsCustomers.status == '5') &&
                        item.subscriptionsCustomers.lastFailedDebitAttempt
                    "
                  >
                    <a-tooltip
                      :title="
                        `Falló el pago el día ${$moment(
                          item.subscriptionsCustomers.lastFailedDebitAttempt
                        ).format('DD/MM/YYYY')} (${
                          item.subscriptionsCustomers.consecutiveFailureAttempts
                        } intentos fallidos). El último período pagado fue ${$moment(
                          item.subscriptionsCustomers.lastPeriodPaid
                        ).format('DD/MM/YYYY')}.`
                      "
                      placement="right"
                      ><a-tag color="orange">Pago Pendiente</a-tag>
                    </a-tooltip>
                  </span>
                  <span v-else-if="item.subscriptionsCustomers.status == '1'">
                    <a-tooltip
                      :title="
                        `Período vigente del ${$moment(
                          item.subscriptionsCustomers.lastPeriodPaid
                        ).format('DD/MM')} al ${$moment(
                          item.subscriptionsCustomers.lastPeriodPaid
                        )
                          .add(1, 'month')
                          .format('DD/MM')}.`
                      "
                      placement="right"
                      ><a-tag color="green">Activo</a-tag>
                    </a-tooltip>
                  </span>
                  <span v-else-if="item.subscriptionsCustomers.status == '5'">
                    <a-tooltip
                      :title="
                        `Se encuentra en período de pruebas del ${$moment(
                          item.subscriptionsCustomers.startDate
                        ).format('DD/MM')} hasta el ${$moment(item.startDate)
                          .add(item.freeTrialDays, 'day')
                          .format('DD/MM')}.`
                      "
                      placement="right"
                      ><a-tag color="blue">Período de Prueba</a-tag>
                    </a-tooltip>
                  </span>
                  <span v-else>
                    <a-tag color="pink">Inactivo</a-tag>
                  </span>
                </span>
                <span slot="title">
                  <p>Precio: {{ formatPrice(item.amount) }}</p>
                  <p>
                    {{
                      customer.paymentCards.filter(
                        card =>
                          card.id == item.subscriptionsCustomers.paymentCardId
                      )[0].ownerName
                    }}
                    <span style="text-transform:uppercase">
                      {{
                        customer.paymentCards.filter(
                          card =>
                            card.id == item.subscriptionsCustomers.paymentCardId
                        )[0].paymentCourier.name
                      }}
                    </span>
                    xxxx xxxx xxxx
                    {{
                      customer.paymentCards.filter(
                        card =>
                          card.id == item.subscriptionsCustomers.paymentCardId
                      )[0].lastFourDigits
                    }}
                    exp:
                    {{
                      customer.paymentCards.filter(
                        card =>
                          card.id == item.subscriptionsCustomers.paymentCardId
                      )[0].expirationDate | moment("MM/YY")
                    }}
                  </p>
                </span>
                <br class="br-sm" />
              </h4>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>

      <div>
        <a-divider orientation="left">Historial de Pagos</a-divider>
        <transactions-list
          :showHeader="true"
          :customerId="customer.id"
        ></transactions-list>
      </div>
    </a-card>
  </div>
</template>

<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
import Vue from "vue";
import gateway from "@/services/gateway";
import utils from "@/services/utils";
import TransactionsList from "@/views/Dashboard/Transactions/TransactionsList";

export default {
  props: ["customerId"],
  components: {
    "transactions-list": TransactionsList
  },
  data() {
    return {
      loading: true,
      editIcon: false,
      customer: null,
      dateFormat: "DD/MM/YYYY",
      options: []
    };
  },
  methods: {
    ...mapActions({
      load: "customers/loadOne"
    }),
    backButton() {
      //this.$emit("backClick");
      this.$router.push(`/customers`);
    },
    async fetchCustomerDetails() {
      try {
        //console.log("params:", params);
        //const id = this.$router.params.id
        this.loading = true;
        const result = await this.load(this.$route.params.id);
        this.loading = false;
        this.customer = store.state.customers.customerDetails;
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    formatDate(date) {
      if (date) {
        const d = new Date(date);
        return d.toLocaleDateString();
      } else return null;
    },
    formatPrice(price) {
      return utils.formatPrice(price);
    },
    handleRoute() {
      if (this.$route.name == "customerDetails") this.fetchCustomerDetails();
    }
    // getCardType(paymentCourierCode) {
    //   return gateway.getCardType(paymentCourierCode);
    // }
  },
  mounted() {
    this.handleRoute();
  },
  watch: {
    //REACTIVE TO MANUAL URL CHANGE
    $route(to) {
      this.handleRoute();
    }
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
</style>

<style lang="css">
.ant-card {
  border-radius: 7px;
}
.ant-card-head-title {
}
.ant-card-body {
  padding-bottom: 9px;
  padding: 17px 32px;
}
/*
.ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow {
  left: 0;
  line-height: 0;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding-left: 20px;
}
.ant-btn-link {
  border: none;
}
*/
.back-button {
  /*background-color: #fff;
  border-color: #777;
  color: #777;*/
  vertical-align: 0.38rem;
}
/*
.back-button:hover {
  background-color: #0190fe;
  border-color: #0190fe;
  color: #fff;
}*/
.back-button .anticon {
  vertical-align: -0.213rem;
}
.ant-collapse-item {
  border-bottom: none !important;
}
/*
h3 {
  font-size: 1.2rem;
}
strong {
  font-weight: normal;
  color: black;
}*/
@media (max-width: 767px) {
  .ant-card-head-wrapper {
  }
  .ant-card-head-title {
    flex-grow: 5;
    /*font-size: 100%;*/
    width: 25rem;
  }
  .ant-card-extra {
    float: inherit !important;
    margin-left: 1rem !important;
    align-self: flex-end;
    vertical-align: middle;
    padding-bottom: 1.28rem;
  }
  .ant-switch {
    margin-left: 0 !important;
  }
  .title-id {
    display: none;
  }
  .hover-title {
    font-size: 1.7rem;
    letter-spacing: -1px;
  }
  .hover-title + .edit-icon {
    display: inline;
  }
  .edit-transaction-button {
    display: inline !important;
  }
  .edit-icon {
    display: none !important;
  }
}
.edit-icon {
  display: none;
  font-size: 13px;
  color: #aaa;
  vertical-align: -0rem;
}
.hover-title {
  cursor: pointer;
}
.hover-title:hover + .edit-icon {
  display: inline;
}
.btn-edit-transaction {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
